import { makeObservable, override } from 'mobx';

import { t } from '@gem/modules/i18n';

import { IGroupData } from 'APP/model/group/groupModel.types';
import { Root } from 'STORE';
import { Groups } from 'STORE/Groups/Groups';

import { Group } from '../Group';

const fillColor = PROJECT_CONFIG.brandColor.slice(1);
const DEFAULT_AVATAR = `data:image/svg+xml,%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2248%22%20height%3D%2248%22%20fill%3D%22%23${fillColor}%22%2F%3E%3Cpath%20d%3D%22M16.0794%2013.63C16.779%2012.9011%2017.7408%2012.48%2018.7569%2012.48H29.3231C30.3392%2012.48%2031.301%2012.9011%2032.0006%2013.63C32.6982%2014.3569%2033.08%2015.3303%2033.08%2016.3333V33.9485C33.08%2034.5723%2032.7302%2035.1428%2032.1758%2035.4234C31.6214%2035.704%2030.9569%2035.6468%2030.458%2035.2756L24.04%2030.4989L17.622%2035.2756C17.1231%2035.6468%2016.4586%2035.704%2015.9042%2035.4234C15.3498%2035.1428%2015%2034.5723%2015%2033.9485V16.3333C15%2015.3303%2015.3818%2014.3569%2016.0794%2013.63Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E`;

export class SavedMessages extends Group {
  constructor(group: IGroupData, groups: Groups, root: Root) {
    super(group, groups, root);
    makeObservable(this);
    this.name = t('saved_message_chat_tittle') as string;
    this.description = t('saved_messages_chat_description_web') as string;
    this.muted = false;
    this._avatarUrl = DEFAULT_AVATAR;
  }

  @override
  get canInviteUsers(): boolean {
    return false;
  }

  @override
  get avatarUrl(): string | null {
    return this._avatarUrl;
  }

  set avatarUrl(_: string | null) {
    this._avatarUrl = DEFAULT_AVATAR;
  }

  get isSavedMessages(): boolean {
    return true;
  }

  get notificationsAvailable(): boolean {
    return false;
  }

  @override
  get avatarTitle(): string {
    return t('saved_message_chat_tittle');
  }

  get canMentionAll(): boolean {
    return false;
  }

  get canBeScheduled(): boolean {
    return true;
  }

  @override
  get canLeaveComment(): boolean {
    return false;
  }
}
